import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Dashboard from './pages/Dashboard';
import Login from './components/auth/Login';
import Signup from './components/auth/signup';
import ForgotPassword from './components/auth/ForgotPassword';
import OrderStep1 from './pages/OrderStep1';
import OrderStep2 from './pages/OrderStep2';
import OrderStep3 from './pages/OrderStep3';
import OrderSuccess from './pages/OrderSuccess';
import Profile from './pages/Profile';
import AdminOrders from './pages/AdminOrders';
import ProtectedRoute from './components/common/ProtectedRoute';
import MedicineDetail from './components/orders/Medecine/MedicineDetail';
import Medicines from './components/orders/Medecine/Medecineall';

import ParamedicalList from './components/orders/ParaMedicalService/ParamedicalList';
import ParamedicalDetail from './components/orders/ParaMedicalService/ParamedicalDetail';
import ParamedicalBooking from './components/orders/ParaMedicalService/ParamedicalBooking';
import ParamedicalCheckout from './components/orders/ParaMedicalService/ParamedicalCheckout';

import DoctorList from './components/orders/Appointment/DoctorList';
import DoctorSlots from './components/orders/Appointment/DoctorSlots';
import BookingForm from './components/orders/Appointment/BookingForm';
import Checkout from './components/orders/Appointment/Checkout';
import BookingSuccess from './components/orders/Appointment/BookingSuccess';

import MedicalTestMain from './components/orders/Medical_Test/MedicalTestMain';
import MedicalTestDetail from './components/orders/Medical_Test/MedicalTestDetail';
import MedicalTestDetailPage from './pages/MedicalTestDetailPage';
import MedicalTestBooking from './components/orders/Medical_Test/MedicalTestBooking';
import MedicalTestList from './components/orders/Medical_Test/MedicalTestList';
import MedicalTestPackages from './components/orders/Medical_Test/MedicalTestPackages';
import TestBookingForm from './components/orders/Medical_Test/TestBookingForm';
import TestPackageDetail from './components/orders/Medical_Test/TestPackageDetail';

import ConsultationPage from './components/orders/Consultancy/ConsultationPage';
import PatientDashboard from './components/orders/Consultancy/PatientDashboard';
import VideoConsultation from './pages/VideoConsultation';

// New Components
import OtpVerification from './components/auth/OtpVerification';
import PrescriptionUpload from './components/orders/Prescription/PrescriptionUpload';
import PrescriptionList from './components/orders/Prescription/PrescriptionList';
import MedicineOrderHistory from './components/orders/Medicine/MedicineOrderHistory';
import OnlineDoctorsList from './components/consultation/OnlineDoctorsList';
import DoctorProfile from './components/consultation/DoctorProfile';
import ChatConsultationList from './components/consultation/ChatConsultationList';
import ChatConsultation from './components/consultation/ChatConsultation';
import AddressManager from './components/user/AddressManager';
import OrderHistory from './pages/OrderHistory';
import Cart from './pages/Cart';

import { CartProvider } from './context/CartContext';
import AddAddress from './pages/AddAddress';

// Legal Pages
import ContactUs from './pages/legal/ContactUs';
import ShippingPolicy from './pages/legal/ShippingPolicy';
import TermsAndConditions from './pages/legal/TermsAndConditions';
import CancellationsAndRefunds from './pages/legal/CancellationsAndRefunds';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import About from './pages/About';

// Notification & Terms Pages
import Notifications from './pages/Notifications';
import NotificationSettings from './pages/NotificationSettings';
import TermsPage from './pages/TermsPage';

import './index.css'; // Import your main CSS file

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-otp" element={<OtpVerification />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/order-step-1" element={<OrderStep1 />} />
            <Route path="/order-step-2" element={<OrderStep2 />} />
            <Route path="/order-step-3" element={<OrderStep3 />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} />
            <Route path="/Medicines" element={<Medicines />} />
            <Route path="/medicine/:id" element={<MedicineDetail />} />
            <Route path="/medicines/orders/history" element={<ProtectedRoute><MedicineOrderHistory /></ProtectedRoute>} />
            
            {/* Prescription Routes */}
            <Route path="/prescriptions" element={<ProtectedRoute><PrescriptionList /></ProtectedRoute>} />
            <Route path="/prescriptions/upload" element={<ProtectedRoute><PrescriptionUpload /></ProtectedRoute>} />
            <Route path="/paramedical" element={<ParamedicalList />} />
            <Route path="/paramedical/:id" element={<ParamedicalDetail />} />
            <Route path="/paramedical/book/:id" element={<ParamedicalBooking />} />
            <Route path="/paramedical/:id/checkout" element={<ParamedicalCheckout />} />
            <Route path="/doctor-list" element={<DoctorList />} />
            <Route path="/doctor-slots" element={<DoctorSlots />} />
            <Route path="/doctor-booking" element={<BookingForm />} />
            <Route path="/doctor-checkout" element={<Checkout />} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/medical-tests" element={<MedicalTestMain />} />
            <Route path="/medical-test/:id" element={<MedicalTestDetailPage />} />
            <Route path="/medical-tests/booking" element={<MedicalTestBooking />} />
            <Route path="/medical-tests/book-appointment" element={<ProtectedRoute><TestBookingForm /></ProtectedRoute>} />
            <Route path="/medical-tests/list" element={<MedicalTestList />} />
            <Route path="/medical-tests/packages" element={<MedicalTestPackages />} />
            <Route path="/test-package/:packageId" element={<TestPackageDetail />} />

            {/* Consultation and Doctor Dashboard */}
            <Route path="/consultation/:id" element={<ConsultationPageWrapper />} />
            <Route path="/PatientDashboard" element={<PatientDashboard />} />
            <Route path="/online-consultation" element={<OnlineDoctorsList />} />
            <Route path="/video-consultation" element={<VideoConsultation />} />
            <Route path="/doctor/:id" element={<DoctorProfile />} />

            {/* Chat Consultation */}
            <Route path="/chat-consultations" element={<ProtectedRoute><ChatConsultationList /></ProtectedRoute>} />
            <Route path="/chat-consultation/:consultationId" element={<ProtectedRoute><ChatConsultation /></ProtectedRoute>} />

            {/* Address Management */}
            <Route path="/user/addresses" element={<ProtectedRoute><AddressManager /></ProtectedRoute>} />
            <Route path="/user/addresses/add" element={<AddAddress />} />

            {/* Order History */}
            <Route path="/order-history" element={<ProtectedRoute><OrderHistory /></ProtectedRoute>} />

            {/* Shopping Cart */}
            <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />

            {/* Notifications */}
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/notifications/settings" element={<ProtectedRoute><NotificationSettings /></ProtectedRoute>} />

            {/* Terms & Policies */}
            <Route path="/terms" element={<TermsPage />} />

            {/* Legal & Policy Pages */}
            <Route path="/about" element={<About />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/cancellations-and-refunds" element={<CancellationsAndRefunds />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

function ConsultationPageWrapper() {
  const { id } = useParams();
  return <ConsultationPage consultationId={id} />;
}

export default App;
